import graphql__0a57ac9c11d5217b3517 from "./__generated__/SendUnlockInstructionsMutation.graphql.js";import { commitMutation } from "react-relay";
import { graphql } from "react-relay";
import mapValues from "lodash/mapValues";
import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__0a57ac9c11d5217b3517;

function sendUnlockInstructions(form, onCompleted) {
  const variables = mapValues(form.fields, field => field.value);

  return commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError: error => console.error(error)
  });
}

export { sendUnlockInstructions };
